package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import one.healthium.domain.common.BMIRange
import one.healthium.domain.common.TextStyle
import one.healthium.onboarding.domain.models.HighlightItem

@Serializable
@SerialName("wellness_profile")
data class WellnessProfileScreenConfig(
    @SerialName("title") val title: String?,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("text_label") val textLabel: TextStyle? = null,
    @SerialName("benefits_title_label") val benefitsTitleLabel: TextStyle? = null,
    @SerialName("emoji_height") val emojiHeight: Int? = null,
    @SerialName("items") val items: List<HighlightItem> = emptyList(),
    @SerialName("underweight_bmi_emoji") val underweightBmiEmoji: String? = null,
    @SerialName("underweight_bmi_title") val underweightBmiTitle: String? = null,
    @SerialName("underweight_bmi_text") val underweightBmiText: String? = null,
    @SerialName("normal_bmi_emoji") val normalBmiEmoji: String? = null,
    @SerialName("normal_bmi_title") val normalBmiTitle: String? = null,
    @SerialName("normal_bmi_text") val normalBmiText: String? = null,
    @SerialName("overweight_bmi_emoji") val overweightBmiEmoji: String? = null,
    @SerialName("overweight_bmi_title") val overweightBmiTitle: String? = null,
    @SerialName("overweight_bmi_text") val overweightBmiText: String? = null,
    @SerialName("obese_bmi_emoji") val obeseBmiEmoji: String? = null,
    @SerialName("obese_bmi_title") val obeseBmiTitle: String? = null,
    @SerialName("obese_bmi_text") val obeseBmiText: String? = null,
) : ScreenConfig {
    @Transient
    val infos = mapOf(
        BMIRange.Underweight to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = underweightBmiEmoji,
            title = underweightBmiTitle,
            text = underweightBmiText,
        ),
        BMIRange.Normal to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = normalBmiEmoji,
            title = normalBmiTitle,
            text = normalBmiText,
        ),
        BMIRange.Overweight to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = overweightBmiEmoji,
            title = overweightBmiTitle,
            text = overweightBmiText,
        ),
        BMIRange.Obese to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = obeseBmiEmoji,
            title = obeseBmiTitle,
            text = obeseBmiText,
        ),
    )
}

@Serializable
@SerialName("wellness_profile_v2")
data class WellnessProfileV2ScreenConfig(
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("text_label") val textLabel: TextStyle? = null,
    @SerialName("benefits_title_label") val benefitsTitleLabel: TextStyle? = null,
    @SerialName("emoji_height") val emojiHeight: Int? = null,
    @SerialName("items") val items: List<HighlightItem> = emptyList(),
    @SerialName("underweight_bmi_emoji") val underweightBmiEmoji: String? = null,
    @SerialName("underweight_bmi_title") val underweightBmiTitle: String? = null,
    @SerialName("underweight_bmi_text") val underweightBmiText: String? = null,
    @SerialName("normal_bmi_emoji") val normalBmiEmoji: String? = null,
    @SerialName("normal_bmi_title") val normalBmiTitle: String? = null,
    @SerialName("normal_bmi_text") val normalBmiText: String? = null,
    @SerialName("overweight_bmi_emoji") val overweightBmiEmoji: String? = null,
    @SerialName("overweight_bmi_title") val overweightBmiTitle: String? = null,
    @SerialName("overweight_bmi_text") val overweightBmiText: String? = null,
    @SerialName("obese_bmi_emoji") val obeseBmiEmoji: String? = null,
    @SerialName("obese_bmi_title") val obeseBmiTitle: String? = null,
    @SerialName("obese_bmi_text") val obeseBmiText: String? = null,
) : ScreenConfig {
    @Transient
    val infos = mapOf(
        BMIRange.Underweight to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = underweightBmiEmoji,
            title = underweightBmiTitle,
            text = underweightBmiText,
        ),
        BMIRange.Normal to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = normalBmiEmoji,
            title = normalBmiTitle,
            text = normalBmiText,
        ),
        BMIRange.Overweight to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = overweightBmiEmoji,
            title = overweightBmiTitle,
            text = overweightBmiText,
        ),
        BMIRange.Obese to WellnessProfileBmiInfo(
            emojiHeight = emojiHeight,
            emoji = obeseBmiEmoji,
            title = obeseBmiTitle,
            text = obeseBmiText,
        ),
    )
}


data class WellnessProfileBmiInfo(
    val emojiHeight: Int?,
    val emoji: String?,
    val title: String?,
    val text: String?,
)
